function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cg)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M242.736 157.866C242.736 157.866 205.7 228.166 214.093 257.834C222.486 287.502 329.493 315.521 329.493 315.521L337.886 328.11L353.273 260.967L295.915 232.992L294.087 139.057",
  fill: "#9068DC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M246.774 285.345C246.774 250.323 264.52 221.932 286.407 221.932C289.599 221.942 292.761 222.544 295.732 223.709L295.914 233.009L315.702 242.666C322.118 253.931 326.03 268.912 326.03 285.353C326.073 294.869 324.693 304.338 321.936 313.446C306.983 309.17 272.777 298.693 246.768 285.53C246.774 285.457 246.774 285.396 246.774 285.345Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255.181 142.121C255.181 142.121 245.763 295.753 272.354 368.487L266.801 376.647H314.086C314.086 376.647 319.252 181.237 319.252 139.063L255.181 142.121Z",
  fill: "#AC7FE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.36 23.254V43.22L294.096 49.3V15.607L269.36 9.52698V23.254Z",
  fill: "#EADCFC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M283.334 30.164C283.7 30.164 283.996 29.8676 283.996 29.502C283.996 29.1364 283.7 28.84 283.334 28.84C282.968 28.84 282.672 29.1364 282.672 29.502C282.672 29.8676 282.968 30.164 283.334 30.164Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.174 30.164C273.54 30.164 273.836 29.8676 273.836 29.502C273.836 29.1364 273.54 28.84 273.174 28.84C272.808 28.84 272.512 29.1364 272.512 29.502C272.512 29.8676 272.808 30.164 273.174 30.164Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.159 33.447V23.254H271.053",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.579 23.254H279.473",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M292.468 28.477V32.016C292.922 32.016 293.371 31.9266 293.79 31.753C294.209 31.5794 294.59 31.3249 294.911 31.004C295.232 30.6832 295.486 30.3023 295.66 29.8832C295.834 29.464 295.923 29.0147 295.923 28.561V28.249C295.865 27.8124 295.644 27.4141 295.303 27.1348C294.962 26.8556 294.528 26.7164 294.089 26.7454C293.649 26.7744 293.237 26.9695 292.936 27.291C292.635 27.6126 292.468 28.0366 292.468 28.477V28.477Z",
  fill: "#F8FFB3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M292.468 32.015C292.922 32.015 293.371 31.9256 293.79 31.752C294.209 31.5784 294.59 31.3239 294.911 31.0031C295.232 30.6822 295.486 30.3014 295.66 29.8822C295.834 29.463 295.923 29.0137 295.923 28.56",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278.387 35.96C279.315 35.96 280.205 35.5913 280.862 34.9349C281.518 34.2785 281.887 33.3883 281.887 32.46",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.36 43.22L294.096 49.3",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.158 33.452L278.387 34.002",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M295.005 26.905C295.005 26.905 302.526 9.74603 286.281 9.52703C286.281 9.52703 272.759 2.15503 267.243 6.81803C261.727 11.481 269.36 19.718 269.36 19.718",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M292.534 27.931C290.608 26.015 289.247 23.6045 288.603 20.965C288.603 20.965 272.167 18.787 269.351 13.658",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M319.246 85.054V139.062L242.736 157.862V97.719C242.736 87.3557 246.211 77.2917 252.605 69.1359C258.999 60.9801 267.942 55.2033 278.006 52.729V52.729C282.908 51.5238 288.021 51.4493 292.956 52.511C297.892 53.5728 302.521 55.7431 306.494 58.8578C310.467 61.9724 313.68 65.9498 315.889 70.4891C318.098 75.0284 319.246 80.0106 319.246 85.059V85.054Z",
  fill: "#FA7F58"
}), /*#__PURE__*/React.createElement("path", {
  d: "M254.551 155.181C254.551 155.181 245.766 295.748 272.351 368.481",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.033 54.378C299.033 54.378 324.641 63.503 329.942 106.178C329.942 106.178 365.411 53.452 380.523 56.236C395.635 59.02 395.234 63.79 392.054 64.587C388.874 65.384 384.104 64.187 384.104 64.187C384.104 64.187 390.632 76.226 374.163 76.511C374.163 76.511 374.563 152.844 333.597 157.619C292.631 162.394 284.579 117.861 284.579 117.861",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M253.563 67.956C253.563 67.956 239.183 87.423 231.723 106.19C231.723 106.19 225.731 55.609 222.398 51.753C214.07 42.12 216.798 53.153 216.798 53.153C216.798 53.153 200.325 45.17 200.632 49.316C200.939 53.462 211.822 64.661 211.822 64.661C211.822 64.661 198.459 118.11 209.337 132.415C220.215 146.72 242.731 147.023 242.731 147.023",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M285.446 121.413C287.922 130.221 296.263 152.686 319.111 157.181L318.999 164.481C290.444 158.855 284.602 117.851 284.602 117.851L285.446 121.413Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.166 138.894C108.166 138.894 176.766 232.512 131.992 303.143C108.623 340.006 100.752 346.66 100.752 346.66V356.298L74.641 324.743L97.241 262.029L56.116 130.543",
  fill: "#E4AB4E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.65 324.746L97.25 262.014L81.332 211.134",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.651 157.699L33.151 376.478H79.522L74.649 367.778C74.649 367.778 94.74 206.684 86.261 138.894",
  fill: "#FFC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74.65 367.777C74.65 367.777 93.436 216.556 86.838 144.135",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.741 23.086V31.693C94.745 34.9318 93.661 38.0782 91.6631 40.6274C89.6651 43.1766 86.869 44.9809 83.723 45.751L70.01 49.123V15.439L81.41 12.639C82.9941 12.2496 84.6461 12.2254 86.241 12.5683C87.8358 12.9112 89.3319 13.6121 90.6161 14.6182C91.9002 15.6242 92.9388 16.909 93.6534 18.3755C94.3681 19.842 94.74 21.4517 94.741 23.083V23.086Z",
  fill: "#FFE1B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.741 31.694C94.745 34.9329 93.661 38.0792 91.6631 40.6284C89.6651 43.1776 86.869 44.9819 83.723 45.752L70.01 49.123",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.767 29.996C81.1326 29.996 81.429 29.6996 81.429 29.334C81.429 28.9684 81.1326 28.672 80.767 28.672C80.4014 28.672 80.105 28.9684 80.105 29.334C80.105 29.6996 80.4014 29.996 80.767 29.996Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.927 29.996C91.2926 29.996 91.589 29.6996 91.589 29.334C91.589 28.9684 91.2926 28.672 90.927 28.672C90.5614 28.672 90.265 28.9684 90.265 29.334C90.265 29.6996 90.5614 29.996 90.927 29.996Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.948 33.279V23.086H93.048",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.522 23.086H84.628",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.638 28.309V31.852C70.7217 31.852 69.8429 31.488 69.1949 30.8401C68.547 30.1921 68.183 29.3133 68.183 28.397V28.085C68.2407 27.6487 68.4621 27.2507 68.8023 26.9715C69.1425 26.6923 69.5761 26.5528 70.0153 26.5813C70.4544 26.6097 70.8664 26.8041 71.1677 27.1248C71.469 27.4456 71.6371 27.8689 71.638 28.309V28.309Z",
  fill: "#FFE4B3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.638 31.848C70.7217 31.848 69.8429 31.484 69.1949 30.8361C68.547 30.1881 68.183 29.3093 68.183 28.393",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.159 35.424C84.7298 35.8529 84.1478 36.0939 83.541 36.0939C82.9342 36.0939 82.3522 35.8529 81.923 35.424",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M87.948 33.284L85.715 33.834",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M71.638 26.565C71.638 26.565 77.76 22.112 78.516 18.074C78.516 18.074 90.793 23.357 97.945 18.694",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M69.907 37.289C69.907 37.289 57.863 33.559 57.998 23.86C58.133 14.161 71.656 10.105 71.656 10.105C71.656 10.105 85.256 -7.00699 96.098 5.20501C106.94 17.417 97.166 35.984 101.362 40.413C105.558 44.842 95.0441 49.92 85.7331 45.113",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M108.165 84.881V138.894L31.655 157.694V97.55C31.6554 87.1867 35.1303 77.1227 41.5241 68.9669C47.9179 60.8111 56.8614 55.0343 66.925 52.56V52.56C71.8275 51.3548 76.9398 51.2802 81.8753 52.3421C86.8108 53.4039 91.4402 55.5743 95.4133 58.6891C99.3863 61.8038 102.599 65.7814 104.808 70.3208C107.017 74.8602 108.165 79.8426 108.165 84.891V84.881Z",
  fill: "#F2458C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.687 143.97L68.737 95.829L70.01 91.12L62.853 146.765L55.687 143.97Z",
  fill: "#131313",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.264 79.608C35.264 79.608 9.68404 115.679 23.364 153.908C33.37 181.884 66.932 181.884 84.231 179.898C87.4005 179.531 90.4472 178.458 93.1471 176.758C95.8469 175.058 98.1309 172.774 99.831 170.074L104.857 168.774C105.805 168.527 106.645 167.972 107.244 167.197C107.843 166.421 108.168 165.469 108.167 164.489V164.489L55.693 143.973L70.008 91.117",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.824 62.841L133.394 93.298C133.394 93.298 170.694 65.322 180.333 62.841C189.972 60.36 195.254 62.841 195.254 62.841C194.895 64.3613 194.051 65.7232 192.848 66.7202C191.646 67.7173 190.151 68.2951 188.591 68.366L187.191 68.431C187.191 68.431 186.571 79.001 179.418 80.866C179.418 80.866 150.705 150.186 108.177 125.008",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.013 192.595H0V204.905H347.013V192.595Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.754 377.11H139.645",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.504 204.424V376.646",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.892 190.156H148.192L166.51 148.14H169.956L151.892 190.156Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.366 193.063H116.572V187.923H219.427L217.366 193.063Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.366 193.063H116.572V187.923H219.427L217.366 193.063Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.511 193.061H150.694L169.96 148.14H236.781L217.511 193.061Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.883 193.061H232.296",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cg"
}, /*#__PURE__*/React.createElement("rect", {
  width: 394.595,
  height: 377.86,
  fill: "white"
})));

var SvgContactGuys = function SvgContactGuys(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395 378",
    fill: "none",
    className: "w-72 sm:w-auto",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactGuys, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ContactGuys.114a3885.svg";
export { ForwardRef as ReactComponent };